import { DeleteOutlined, MoreOutlined } from '@ant-design/icons';
import { Contact } from '@mm/state/interfaces/contacts';
import { EmailVerificationStatusIcon } from '@mm/components';
import { Dropdown, Tooltip } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import React, { MouseEvent } from 'react';
import CheckBox from '../../../../../../common/components/Checkbox';
import { GridCell } from '../../../../../../common/components/Grid/Grid';
import { remappedNames } from '../MyLeadsFiltersPanel/helpers';
import styles from './MyLeadsContactsTable.module.css';
import { ReactComponent as BusinessIcon } from 'assets/icons/business-outlined.svg';

const renderTextCell = ({
  contact,
  key,
}: {
  contact: Contact;
  onClick: () => void;
  key: string;
}) => {
  let formatted;

  switch (key) {
    case 'createdAt':
      formatted = moment(contact[key]).utc().format('MM/DD/YYYY');
      break;
    case 'source':
      formatted = remappedNames(contact[key] || '', 'CSV').friendlyName;
      break;
    case 'type':
      formatted = contact[key]?.join(',');
      break;
    default:
      formatted = contact[key];
  }

  return (
    <GridCell className={styles.gridCell} key={`${key}-${contact.id}`}>
      <div className={styles.textCell}>{formatted}</div>
    </GridCell>
  );
};

const renderEmailCell = ({
  contact,
  key,
}: {
  contact: Contact;
  key: string;
}) => (
  <GridCell className={styles.gridCell} key={`${key}-${contact.id}`}>
    {contact?.businessContact && (
      <BusinessIcon className={styles.businessIcon} />
    )}
    <EmailVerificationStatusIcon
      contact={contact}
      className="contacts-grid__email-cell-icon"
    />
    <div className={classNames(styles.textCell, styles.lowercased)}>
      {contact[key]}
    </div>
  </GridCell>
);

const renderCheckboxCell = ({
  contact,
  key,
  isChecked,
  disabled,
  onClick,
}: {
  contact: Contact;
  key: string;
  onClick?: (e?: MouseEvent<HTMLInputElement>) => void;
  isChecked?: boolean;
  disabled?: boolean;
}) => {
  const generateName = () => {
    if (
      contact.firstName === 'Instagram Contact' &&
      contact.lastName === 'IG' &&
      contact.username
    ) {
      return `@${contact.username}`;
    }
    if (contact.fullName) {
      return `${contact.fullName}`;
    }
    if (contact.username) {
      return `@${contact.username}`;
    }
    return '';
  };
  return (
    <GridCell className={styles.gridCell} key={`${key}-${contact.id}`}>
      <CheckBox
        isChecked={isChecked || false}
        className={styles.checkbox}
        disabled={disabled}
        onClick={onClick}
        name={contact.id.toString()}
      />
      <div className={classNames(styles.textCell, styles.firstNameTextCell)}>
        {generateName().toLowerCase()}
      </div>
    </GridCell>
  );
};

const renderActionsCell = ({
  contact,
  key,
  onClick,
}: {
  contact: Contact;
  key: string;
  onClick: (e?: Event) => void;
}) => {
  const items = [
    {
      key: '1',
      label: (
        <div
          className={styles.menuItem}
          onClick={e => {
            e.stopPropagation();
            onClick();
          }}
        >
          <DeleteOutlined />
          Delete
        </div>
      ),
    },
  ];
  return (
    <GridCell
      className={styles.gridCell}
      key={`${key}-${contact.id}`}
      onClick={e => e.stopPropagation()}
    >
      <Dropdown menu={{ items }} trigger={['click']}>
        <MoreOutlined />
      </Dropdown>
    </GridCell>
  );
};

const renderSourceCell = ({
  contact,
  key,
}: {
  contact: Contact;
  key: string;
}) => {
  const tag = () => {
    switch (contact.source) {
      case 're_signaled':
        return (
          <span className={classNames(styles.sourceCell, styles.resignaled)}>
            Re-signaled
          </span>
        );
      case 'x-ray':
        return (
          <span className={classNames(styles.sourceCell, styles.xray)}>
            X-Ray
          </span>
        );
      default:
        return contact.source;
    }
  };
  return (
    <GridCell
      className={styles.gridCell}
      key={`${key}-${contact.id}`}
      onClick={e => e.stopPropagation()}
    >
      {tag()}
    </GridCell>
  );
};

const renderTypeCell = ({
  contact,
  key,
}: {
  contact: Contact;
  key: string;
}) => {
  const types = contact.type?.join(', ');
  return (
    <GridCell className={styles.gridCell} key={`${key}-${contact.id}`}>
      <Tooltip title={types}>
        <div className={styles.textCell}>{types}</div>
      </Tooltip>
    </GridCell>
  );
};

export const CONTACTS_TABLE_CELL_DATA = [
  {
    label: 'Name',
    key: 'fullName',
    Cell: renderCheckboxCell,
  },
  {
    label: 'Email',
    key: 'email',
    Cell: renderEmailCell,
  },
  {
    label: 'Phone',
    key: 'phone',
    Cell: renderTextCell,
  },
  {
    label: 'Source',
    key: 'source',
    Cell: renderSourceCell,
  },
  {
    label: 'Type',
    key: 'type',
    Cell: renderTypeCell,
  },
  {
    label: 'Date Created',
    key: 'createdAt',
    Cell: renderTextCell,
  },
  // {
  //   label: 'Automation',
  //   key: 'automation',
  //   Cell: renderTextCell,
  // },
  {
    label: '',
    key: 'action',
    Cell: renderActionsCell,
  },
];
